import { render, staticRenderFns } from "./PublicMobileLayout.vue?vue&type=template&id=39707550&lang=pug&"
import script from "./PublicMobileLayout.vue?vue&type=script&lang=js&"
export * from "./PublicMobileLayout.vue?vue&type=script&lang=js&"
import style0 from "./PublicMobileLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports